import axios from 'axios'
import HTTP from './http'

export default {
    getOpenSessions: () => axios.get(HTTP.GET_OPEN_WHATSAPP_SESSIONS),
    updateSession: (payload) => axios.post(HTTP.UPDATE_WHATSAPP_SESSION, { ...payload }),
    getAllsteps: () => axios.get(HTTP.GET_WHATSAPP_STEPS),
    resetSession: (payload) => axios.post(HTTP.RESET_WHATSAPP_SESSION, { ...payload }),
    deleteSession: (payload) => axios.delete(HTTP.DELETE_WHATSAPP_SESSION, { params: { ...payload } })
}